import { PLATFORM_FULL_ACCESS_FEATURE_ID } from '@/app/platform/platform-core/platform-mode/platform-mode.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { EgiRoutes } from '@ervo/page-framework';
import { EgiAppEditorPageComponent } from '@/app/egi.pages/platform-management.pages/egi-apps/egi-app-editor-page/egi-app-editor-page.component';
// eslint-disable-next-line max-len
import { EgiAppManagementBlockModule } from '@/app/platform/platform-management/egi-app-management-block/egi-app-management-block.module';
import { PresentUsersManagementBlockModule } from '@/app/platform/platform-management/present-users-management-block/present-users-management-block.module';
import { UserGroupBlockModule } from '@/app/platform/platform-management/user-group-block/user-group-block.module';
import { PresentUsersLiveDashboardPageComponent } from '@/app/egi.pages/platform-management.pages/present-users/present-users-live-dashboard-page/present-users-live-dashboard-page.component';
// eslint-disable-next-line max-len
import { UserGroupsPageComponent } from '@/app/egi.pages/platform-management.pages/user-groups/user-groups-page/user-groups-page.component';
import { SharedModule } from '@shared/shared.module';
import { PAnnouncementManagementComponent } from './notifications/p-announcement-management/p-announcement-management.component';
import { NotificationManagementModuleModule } from '@/app/platform/platform-management/notification-management-module/notification-management-module.module';
import { NgSelectModule } from '@ng-select/ng-select';
import { StyleGuidePageComponent } from '@/app/core/pages/style-guide-page/style-guide-page.component';
import { PlatformNotificationsModule } from '@/app/platform/platform-core/platform-notifications/platform-notifications.module';
// eslint-disable-next-line max-len
import { AccountManagementPageComponent } from '@/app/egi.pages/platform-management.pages/accounts/account-management-page/account-management-page.component';
// eslint-disable-next-line max-len
import { RegistrationManagementPageComponent } from '@/app/egi.pages/platform-management.pages/accounts/registration-management-page/registration-management-page.component';
// eslint-disable-next-line max-len
import { AccountManagementViewComponent } from '@/app/platform/platform-management/account-management-block/views/account-management-view/account-management-view.component';
// eslint-disable-next-line max-len
import { RegistrationSettingsPanelComponent } from '@/app/platform/platform-management/account-management-block/containers/registration-settings-panel/registration-settings-panel.component';
import { SupportAdminPageComponent } from '@/app/support/pages/support-admin-page.component';
// eslint-disable-next-line max-len
import { SystemStatusPanelComponent } from '@/app/platform/platform-management/system-status/system-status-panel.component';

@NgModule({
  declarations: [
    EgiAppEditorPageComponent,
    PresentUsersLiveDashboardPageComponent,
    UserGroupsPageComponent,
    PAnnouncementManagementComponent,
    StyleGuidePageComponent,
    AccountManagementPageComponent,
    RegistrationManagementPageComponent
  ],
  imports: [
    CommonModule,
    EgiAppManagementBlockModule,
    PresentUsersManagementBlockModule,
    UserGroupBlockModule,
    SharedModule,
    NgSelectModule,
    NotificationManagementModuleModule,
    PlatformNotificationsModule,
    AccountManagementViewComponent,
    RegistrationSettingsPanelComponent,
    SupportAdminPageComponent,
    SystemStatusPanelComponent
  ]
})
export class PlatformManagementPagesModule {
  static routes: EgiRoutes = [
    {
      path: 'apps',
      children: [
        {
          path: '',
          component: EgiAppEditorPageComponent,
          data: {
            config: {
              id: '2045dd6c-c066-471d-913e-5590d13fab8a',
              name: 'Apps bewerken',
              features: {
                edit: {
                  id: '431fc816-6675-455a-8e8a-366a32f28b42',
                  displayKey: 'edit'
                }
              },
              topic: 'Beheer'
            }
          }
        }
      ]
    },
    {
      path: 'present-users',
      children: [
        {
          path: 'live',
          component: PresentUsersLiveDashboardPageComponent,
          data: {
            config: {
              id: '32c4d0e1-ec5a-4053-9d84-d6b8bc51c18b',
              name: 'Present users - live',
              topic: 'Beheer',
              features: {
                forceStopAll: {
                  id: '363a0d5d-5ca8-44dd-8ddb-e82ae6da6288',
                  displayKey: ''
                },
                forceInvalidateAll: {
                  id: 'f25d1734-df75-4c88-b56e-c74afa7a5112',
                  displayKey: ''
                },
                forceStop: {
                  id: 'cc2ba3ff-96f5-4a7b-bebf-4f0e617a56b5',
                  displayKey: ''
                },
                forceInvalidate: {
                  id: 'e3bcd543-a7bf-4a9a-8cf6-c6a58f30c19a',
                  displayKey: ''
                }
              }
            }
          }
        }
      ]
    },
    {
      path: 'accounts',
      children: [
        {
          path: '',
          component: AccountManagementPageComponent,
          data: {
            config: {
              name: 'Accountbeheer',
              features: {
                edit: {
                  id: 'ed170000-0000-0000-0000-00000000ed17',
                  displayKey: 'edit'
                }
              },
              id: 'f4c8a9d2-6e1b-4f3a-9c7d-8b2e5a1f0c64',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        },
        {
          path: 'registration',
          component: RegistrationManagementPageComponent,
          data: {
            config: {
              name: 'Registratiebeheer',
              features: {
                edit: {
                  id: 'ed170000-0000-0000-0000-00000000ed17',
                  displayKey: 'edit'
                },
                // Platformmodi (issue #51): wie dit heeft, merkt van geen enkele modus iets
                fullAccess: {
                  id: PLATFORM_FULL_ACCESS_FEATURE_ID,
                  displayKey: 'fullAccess'
                }
              },
              id: '3727e82e-fa5b-484b-a2ed-16c99004571f',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        }
      ]
    },
    {
      path: 'user-groups',
      children: [
        {
          path: '',
          component: UserGroupsPageComponent,
          data: {
            config: {
              name: 'Gebruikersgroepen',
              features: {},
              id: '5a1aa4db-f547-451f-8ef4-68543fbda3ed',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        }
      ]
    },
    {
      path: 'notifications',
      children: [
        {
          path: 'announcements',
          component: PAnnouncementManagementComponent,
          data: {
            config: {
              name: 'Mededelingen beheer',
              features: {},
              id: 'b1bf6520-7a29-4ee5-a5b1-8961731fc514',
              clickTroughPages: {},
              topic: 'Notificaties'
            }
          }
        }
      ]
    },
    {
      path: 'support',
      children: [
        {
          path: '',
          component: SupportAdminPageComponent,
          data: {
            config: {
              name: 'Support',
              features: {
                use: {
                  id: 'feed0000-0000-0000-0000-00000000feed',
                  displayKey: 'use'
                },
                manage: {
                  id: 'feedbe00-0000-0000-0000-0000feedbe00',
                  displayKey: 'manage'
                }
              },
              id: '6b1f0c2e-3d4a-4e5f-9a8b-7c6d5e4f3a21',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        }
      ]
    },
    {
      path: 'system-status',
      children: [
        {
          path: '',
          component: SystemStatusPanelComponent,
          data: {
            config: {
              name: 'Systeemstatus',
              features: {
                edit: {
                  id: 'ed170000-0000-0000-0000-00000000ed17',
                  displayKey: 'edit'
                }
              },
              id: 'f2c78970-3567-4335-9a74-459d5356508b',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        }
      ]
    },
    {
      path: 'style-guide',
      children: [
        {
          path: '',
          component: StyleGuidePageComponent,
          data: {
            config: {
              name: 'Style guide',
              features: {},
              id: '7f3e1c2a-9b4d-4e6f-8a1b-2c3d4e5f6a7b',
              clickTroughPages: {},
              topic: 'Beheer'
            }
          }
        }
      ]
    }
  ];
}
